import { apiClient } from './api';
import type { ApiResponse, TenantConfig } from '@/types';

export async function getTenantConfig(): Promise<ApiResponse<TenantConfig>> {
  return apiClient.get<TenantConfig>('/settings/tenant');
}

export type UpdateTenantConfigRequest = Partial<TenantConfig>;

export async function updateTenantConfig(payload: UpdateTenantConfigRequest): Promise<ApiResponse<TenantConfig>> {
  return apiClient.put<TenantConfig>('/settings/tenant', payload);
}
